var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDocumentDuplicate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.94853 1.25C6.28579 1.25 5.74854 1.78726 5.74854 2.45V3.30029H6.70138C7.41747 3.30029 8.10422 3.58476 8.61057 4.0911L11.1076 6.58816C11.614 7.09451 11.8984 7.78127 11.8984 8.49735V10.85H12.5485C13.2113 10.85 13.7485 10.3127 13.7485 9.65V4.94706C13.7485 4.6288 13.6221 4.32357 13.3971 4.09853L10.9 1.60147C10.675 1.37643 10.3697 1.25 10.0515 1.25H6.94853ZM5.74854 4.80029H3.59844C2.9357 4.80029 2.39844 5.33755 2.39844 6.00029V13.2003C2.39844 13.863 2.9357 14.4003 3.59844 14.4003H9.19844C9.86118 14.4003 10.3984 13.863 10.3984 13.2003V10.85V8.49735C10.3984 8.17909 10.272 7.87387 10.047 7.64882L7.54991 5.15176C7.32487 4.92672 7.01964 4.80029 6.70138 4.80029H5.74854Z",
    fill: "#626B7F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocumentDuplicate);
export default __webpack_public_path__ + "static/media/icon-document-duplicate.50c0b951eba3d0e668ed1a12354890db.svg";
export { ForwardRef as ReactComponent };